module.exports = "pegasus/assets/theme2/medium/6.jpg";